module.exports = __webpack_public_path__ + "static/img/diy-system.e41cd03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/reformat/diy-system.png
// module id = lEnJ
// module chunks = 0